export const translations = {
  fr: {
    "Primary": "Navigation principale",
    "Sign In": "Se connecter",
    "Register": "S'inscrire",
    "Forgot Password": "Mot de passe oublié",
    "Search": "Recherche",
    "My Events": "Mes events",
    "Dashboard": "Dashboard",
    "Participants": "Participants",
    "Organizations": "Organisations",
    "Events": "Events",
    "Statistics": "Statistiques",
    "View Profile": "Voir le profil",
    "Log out": "Déconnexion",
    "Admin": "Admin",
    "Organization Account": "Compte organisation",
    "Participant": "Participant",
    "Organization": "Organisation",
    "Language": "Langue",
    "Theme": "Thème",
    "System": "Système",
    "Light": "Clair",
    "Dark": "Sombre",
    "English": "Anglais",
    "French": "Français",
    "Loading…": "Chargement…",
    "Loading...": "Chargement...",
    "Participant profile": "Profil participant",
    "Back to Event Detail": "Retour au détail de l'event",
    "Remove Registration": "Supprimer l'inscription",
    "Removing...": "Suppression...",
    "Remove this participant from the event? They will receive an email notification.": "Supprimer ce participant de l'event ? Il recevra un email de notification.",
    "Unable to remove this registration.": "Impossible de supprimer cette inscription.",
    "Bio": "Bio",
    "Add a short bio to help others understand your academic or professional focus.": "Ajoutez une courte bio pour aider les autres à comprendre votre parcours académique ou professionnel.",
    "Research Interests": "Centres d'intérêt de recherche",
    "Links": "Liens",
    "No public links added yet.": "Aucun lien public ajouté pour le moment.",
    "Missions Accomplished": "Missions accomplies",
    "Profile Type": "Type de profil",
    "Professional": "Professionnel",
    "Student": "Étudiant",
    "Company": "Entreprise",
    "Job Title": "Poste",
    "Time in Company": "Ancienneté",
    "Favorite Domain": "Domaine favori",
    "Events Joined": "Events rejoints",
    "School": "École",
    "Study Level": "Niveau d'études",
    "Confirmed Events": "Events confirmés",
    "Not provided": "Non renseigné",
    "First registration unlocked": "Première inscription débloquée",
    "Ready for first registration": "Prêt pour une première inscription",
    "You have already joined your first Neurovent experience.": "Vous avez déjà rejoint votre première expérience Neurovent.",
    "Register for your first event to unlock this mission.": "Inscrivez-vous à votre premier event pour débloquer cette mission.",
    "{{count}} / 1 event": "{{count}} / 1 event",
    "Confirmed regular": "Habitué confirmé",
    "Building momentum": "Vous prenez de l'élan",
    "{{count}} confirmed events on your journey already.": "{{count}} events confirmés déjà à votre actif.",
    "Reach 3 confirmed events to unlock your regular badge.": "Atteignez 3 events confirmés pour débloquer ce badge.",
    "{{count}} / 3 confirmed events": "{{count}} / 3 events confirmés",
    "Domain curator": "Curateur de domaines",
    "Curate your interests": "Affinez vos intérêts",
    "Your research interests show a clear scientific identity.": "Vos intérêts de recherche montrent une identité scientifique claire.",
    "Pick at least 3 research interests to earn this badge.": "Choisissez au moins 3 centres d'intérêt pour obtenir ce badge.",
    "{{count}} / 3 interests selected": "{{count}} / 3 centres d'intérêt sélectionnés",
    "Waitlist survivor": "Survivant de waitlist",
    "Fast responder": "Réponse rapide",
    "You have already navigated at least one waitlist.": "Vous avez déjà traversé au moins une waitlist.",
    "Stay reactive and register early to keep this badge shiny.": "Restez réactif et inscrivez-vous tôt pour garder ce badge intact.",
    "{{count}} / 1 waitlist experience": "{{count}} / 1 expérience de waitlist",
    "No email provided": "Aucun email renseigné",
    "Edit Profile": "Modifier le profil",
    "My Profile": "Mon profil",
    "Participant Profile": "Profil participant",
    "Organization Profile": "Profil organisation",
    "Event Detail": "Détail de l'event",
    "Create Event": "Créer un event",
    "Admin Participants": "Admin participants",
    "Admin Organizations": "Admin organisations",
    "Admin Events": "Admin events",
    "Admin Statistics": "Admin statistiques",
    "About": "À propos",
    "No organization description added yet.": "Aucune description d'organisation ajoutée pour le moment.",
    "Public organization profile": "Profil public de l'organisation",
    "Edit Organization": "Modifier l'organisation",
    "Total Events": "Nombre total d'events",
    "Upcoming Events": "Events à venir",
    "Live Events": "Events en cours",
    "Past Events": "Events passés",
    "Open public events from this organization": "Ouvrir les events publics de cette organisation",
    "See the next public events from this organization": "Voir les prochains events publics de cette organisation",
    "Organization Links": "Liens de l'organisation",
    "Website": "Site web",
    "YouTube": "YouTube",
    "Twitter / X": "Twitter / X",
    "Instagram": "Instagram",
    "Facebook": "Facebook",
    "Managed Research Domains": "Domaines de recherche gérés",
    "First event created": "Premier event créé",
    "Ready to publish": "Prêt à publier",
    "Your organization has already launched its first event.": "Votre organisation a déjà lancé son premier event.",
    "Publish your first event to unlock this badge.": "Publiez votre premier event pour débloquer ce badge.",
    "{{count}} / 1 event published": "{{count}} / 1 event publié",
    "Verified organization": "Organisation vérifiée",
    "Verification in progress": "Vérification en cours",
    "Your organization identity has been verified.": "L'identité de votre organisation a été vérifiée.",
    "Keep your organization details complete to speed up verification.": "Gardez les informations de l'organisation complètes pour accélérer la vérification.",
    "Review pending": "Vérification en attente",
    "Profile still incomplete": "Profil encore incomplet",
    "Event operator": "Opérateur d'events",
    "Growing event pipeline": "Pipeline d'events en croissance",
    "{{count}} events created and tracked from your dashboard.": "{{count}} events créés et suivis depuis votre dashboard.",
    "Create 5 events to unlock your operator badge.": "Créez 5 events pour débloquer votre badge opérateur.",
    "{{count}} / 5 events created": "{{count}} / 5 events créés",
    "Audience builder": "Créateur d'audience",
    "{{count}} registrations accumulated across your events.": "{{count}} inscriptions cumulées sur vos events.",
    "Reach 20 total registrations to unlock this mission.": "Atteignez 20 inscriptions au total pour débloquer cette mission.",
    "{{count}} / 20 registrations": "{{count}} / 20 inscriptions",
    "No contact email provided": "Aucun email de contact renseigné",
    "Welcome Back": "Connexion participant",
    "Participant Login": "Connexion participant",
    "Organization Dashboard": "Dashboard organisation",
    "Organization Login": "Connexion entreprise",
    "Manage your events, registrations and verification workflow.": "Gérez vos events, inscriptions et votre workflow de vérification.",
    "Sign in to manage your event registrations and discover new opportunities.": "Connectez-vous pour gérer vos inscriptions aux events et découvrir de nouvelles opportunités.",
    "Organization Identifier": "Identifiant organisation",
    "Company Identifier": "Identifiant entreprise",
    "Email Address": "Adresse email",
    "your-organization-identifier": "votre-identifiant-organisation",
    "participant@institution.edu": "participant@institution.edu",
    "Security Key": "Clé de sécurité",
    "Password": "Mot de passe",
    "Forgot password?": "Mot de passe oublié ?",
    "Connecting...": "Connexion...",
    "Access Organization Dashboard": "Accéder au dashboard organisation",
    "Sign In to Dashboard": "Se connecter au dashboard",
    "Not an organization?": "Pas une organisation ?",
    "No account yet?": "Pas encore de compte ?",
    "Participant sign up": "Inscription participant",
    "Register now": "S'inscrire maintenant",
    "Letters, numbers and hyphens only. This identifier will be used for organization login.": "Lettres, chiffres et tirets uniquement. Cet identifiant sera utilisé pour la connexion de l'organisation.",
    "Enter your SIRET and legal representative details.": "Renseignez votre SIRET et les informations du représentant légal.",
    "Automatic verification runs right after account creation.": "La vérification automatique démarre juste après la création du compte.",
    "Use your organization identifier to sign in later.": "Utilisez ensuite votre identifiant d'organisation pour vous connecter.",
    "Create your attendee profile in a few fields.": "Créez votre profil participant en quelques champs.",
    "Track registrations and confirmations from one dashboard.": "Suivez inscriptions et confirmations depuis un seul dashboard.",
    "Discover events in AI, ML and neuroscience.": "Découvrez des events en IA, ML et neurosciences.",
    "Passwords do not match.": "Les mots de passe ne correspondent pas.",
    "SIRET must contain exactly 14 digits.": "Le SIRET doit contenir exactement 14 chiffres.",
    "Profile Created!": "Profil créé !",
    "Organization Account Created!": "Compte organisation créé !",
    "Redirecting to login...": "Redirection vers la connexion...",
    "We have started the organization verification checks. Redirecting to login...": "La vérification de l'organisation a commencé. Redirection vers la connexion...",
    "Empower your": "Développez votre",
    "organization.": "organisation.",
    "Start your": "Commencez votre",
    "scientific": "parcours",
    "journey.": "scientifique.",
    "Create your organization account and submit the legal details needed for verification.": "Créez votre compte organisation et soumettez les informations légales nécessaires à la vérification.",
    "Connect with top organizations and participants worldwide.": "Connectez-vous avec des organisations et participants de premier plan dans le monde entier.",
    "First Name": "Prénom",
    "Given name": "Prénom",
    "Last Name": "Nom",
    "Family name": "Nom de famille",
    "Academic Email": "Email académique",
    "Institution": "Institution",
    "optional": "optionnel",
    "e.g. Sorbonne Université, CNRS": "ex. Sorbonne Université, CNRS",
    "e.g. Neuralink, DeepMind": "ex. Neuralink, DeepMind",
    "Your organization account is checked using the declared SIRET and the legal representative name.": "Le compte organisation est vérifié à partir du SIRET déclaré et du nom du représentant légal.",
    "e.g. INRIA Paris, NeuroSpin Organization": "ex. INRIA Paris, Organisation NeuroSpin",
    "Recovery Email": "Email de récupération",
    "contact@organization.com": "contact@organisation.com",
    "Identifier": "Identifiant",
    "e.g. neurocog-organization-paris": "ex. neurocog-organisation-paris",
    "Use only letters, numbers, and hyphens.": "Utilisez uniquement des lettres, chiffres et tirets.",
    "14 digits required for automatic company verification.": "14 chiffres sont requis pour la vérification automatique de l'entreprise.",
    "{{count}}/14 digits entered": "{{count}}/14 chiffres saisis",
    "Legal Representative": "Représentant légal",
    "e.g. Marie Dupont": "ex. Marie Dupont",
    "Enter the name of the person who legally represents the company.": "Saisissez le nom de la personne qui représente légalement l'entreprise.",
    "Confirm Password": "Confirmer le mot de passe",
    "Passwords match": "Les mots de passe correspondent",
    "Processing...": "Traitement...",
    "Create Profile": "Créer le profil",
    "Register Organization": "Inscrire l'organisation",
    "Already have an account?": "Vous avez déjà un compte ?",
    "Log In": "Se connecter",
    "At least 8 characters": "Au moins 8 caractères",
    "One uppercase letter (A–Z)": "Une lettre majuscule (A–Z)",
    "One number (0–9)": "Un chiffre (0–9)",
    "One special character (!@#…)": "Un caractère spécial (!@#…)",
    "Reset Password": "Réinitialiser le mot de passe",
    "Enter your email and we will send you a password reset link.": "Entrez votre email et nous vous enverrons un lien de réinitialisation.",
    "Something went wrong.": "Une erreur s'est produite.",
    "Check your inbox": "Vérifiez votre boîte mail",
    "If an account exists for": "Si un compte existe pour",
    "a reset link has been sent.": "un lien de réinitialisation a été envoyé.",
    "Sending...": "Envoi...",
    "Send Reset Link": "Envoyer le lien de réinitialisation",
    "Back to Login": "Retour à la connexion",
    "Invalid reset link. Please request a new one.": "Lien de réinitialisation invalide. Veuillez en demander un nouveau.",
    "Password updated!": "Mot de passe mis à jour !",
    "Your password has been reset successfully.": "Votre mot de passe a bien été réinitialisé.",
    "Set New Password": "Définir un nouveau mot de passe",
    "Choose a strong password for your account.": "Choisissez un mot de passe fort pour votre compte.",
    "New Password": "Nouveau mot de passe",
    "Updating...": "Mise à jour...",
    "Update Password": "Mettre à jour le mot de passe",
    "Connect with global scientists. Host and join world-class conferences in AI, ML and Neuroscience.": "Connectez-vous avec des scientifiques du monde entier. Organisez et rejoignez des conférences de premier plan en IA, ML et neurosciences.",
    "Browse all events": "Voir tous les events",
    "Search events,": "Rechercher des events,",
    "organizations, and ideas.": "organisations et idées.",
    "Start with an event title, an organization name, a city, a topic, or a format. We will take you straight to the full results view.": "Commencez avec un titre d'event, un nom d'organisation, une ville, un topic ou un format. Nous vous emmenons directement vers la vue complète des résultats.",
    "Search events, organizations, locations...": "Rechercher des events, organisations, lieux...",
    "Format": "Format",
    "All Events": "Tous les events",
    "In-Person": "En présentiel",
    "Online": "En ligne",
    "Hybrid": "Hybride",
    "Popular topics": "Topics populaires",
    "Popular picks from the community": "Sélections populaires de la communauté",
    "Rotating selection based on real registration and event data": "Sélection tournante basée sur les vraies données d'inscription et d'event",
    "Most registered": "Le plus inscrit",
    "Almost full": "Presque complet",
    "Manual review": "Validation manuelle",
    "Online event": "Event en ligne",
    "Unlimited capacity": "Capacité illimitée",
    "Organizer": "Organisateur",
    "TBD": "À définir",
    "{{count}} registered": "{{count}} inscrits",
    "Closes {{date}}": "Clôture {{date}}",
    "Closes in {{count}} day{{suffix}}": "Clôture dans {{count}} jour{{suffix}}",
    "Closes in {{count}} hour{{suffix}}": "Clôture dans {{count}} heure{{suffix}}",
    "Closes in {{count}} min": "Clôture dans {{count}} min",
    "Open until start": "Ouvert jusqu'au début",
    "No events available yet": "Aucun event disponible pour le moment",
    "As soon as events are published, this search page will surface popular picks here.": "Dès que des events seront publiés, cette page affichera ici les sélections populaires.",
    "A global view of your event activity, registrations, and overall publishing performance.": "Une vue globale de l'activité de vos events, des inscriptions et de la performance globale de publication.",
    "Total views": "Vues totales",
    "Combined views across your published event pages": "Vues cumulées sur vos pages d'events publiés",
    "Total registrations": "Inscriptions totales",
    "All participant registrations received so far": "Toutes les inscriptions participants reçues jusqu'ici",
    "Pending requests": "Demandes en attente",
    "Registrations waiting for organization review": "Inscriptions en attente de validation par l'organisation",
    "Confirmed participants": "Participants confirmés",
    "Participants already approved and confirmed": "Participants déjà approuvés et confirmés",
    "Waitlist count": "Nombre en waitlist",
    "Participants currently waiting for a seat": "Participants actuellement en attente d'une place",
    "Average fill rate": "Taux de remplissage moyen",
    "Confirmed participants compared with total capacity": "Participants confirmés comparés à la capacité totale",
    "Upcoming events": "Events à venir",
    "Published events that have not started yet": "Events publiés qui n'ont pas encore commencé",
    "Past events": "Events passés",
    "Events whose end date is already behind us": "Events dont la date de fin est déjà passée",
    "Cancellation rate": "Taux d'annulation",
    "Share of registrations cancelled after sign-up": "Part des inscriptions annulées après l'inscription",
    "Download Summary CSV": "Télécharger le CSV résumé",
    "Download Performance CSV": "Télécharger le CSV performance",
    "Event history filter": "Filtre d'historique des events",
    "Current Events": "Events en cours",
    "History": "Historique",
    "No past events yet.": "Aucun event passé pour le moment.",
    "You have not created any current events yet.": "Vous n'avez pas encore créé d'event en cours.",
    "Create your first event": "Créer votre premier event",
    "Access every event you have created, review registration volume, and jump into details.": "Accédez à tous les events que vous avez créés, suivez le volume d'inscriptions et ouvrez rapidement le détail.",
    "Create New Event": "Créer un nouvel event",
    "Back to My Events": "Retour à mes events",
    "Basic Info": "Informations de base",
    "Schedule": "Planification",
    "Preview": "Aperçu",
    "Event Title": "Titre de l'event",
    "Research Tags": "Tags de recherche",
    "e.g. International Workshop on Neural Signal Processing": "ex. Atelier international sur le traitement des signaux neuronaux",
    "Loading tags...": "Chargement des tags...",
    "Add a tag…": "Ajouter un tag…",
    "No tags available": "Aucun tag disponible",
    "Continue to Schedule": "Continuer vers la planification",
    "Start Date": "Date de début",
    "Start Time": "Heure de début",
    "End Date": "Date de fin",
    "End Time": "Heure de fin",
    "Calculated Duration": "Durée calculée",
    "Ends on another day": "Se termine un autre jour",
    "Enable this only for events that continue past midnight.": "Activez ceci uniquement pour les events qui continuent après minuit.",
    "Same-day events must end before midnight.": "Les events sur une seule journée doivent se terminer avant minuit.",
    "The event start date and time cannot be in the past. Please choose a future time.": "La date et l'heure de début de l'event ne peuvent pas être dans le passé. Choisissez un horaire futur.",
    "The start date and time cannot be in the past. Please choose a future time.": "La date et l'heure de début ne peuvent pas être dans le passé. Choisissez un horaire futur.",
    "The end date must be different from the start date when \"Ends on another day\" is enabled. If the event ends the same day, uncheck this option.": "La date de fin doit être différente de la date de début quand l'option \"Se termine un autre jour\" est activée. Si l'event se termine le même jour, décochez cette option.",
    "The end date cannot be before the start date. Choose a later end date or disable the multi-day option.": "La date de fin ne peut pas être antérieure à la date de début. Choisissez une date de fin plus tardive ou désactivez l'option multi-jours.",
    "For a same-day event, the end time must be after the start time. If the event continues overnight, enable \"Ends on another day\".": "Pour un event sur une seule journée, l'heure de fin doit être après l'heure de début. Si l'event continue pendant la nuit, activez \"Se termine un autre jour\".",
    "For a same-day event, the end time must be after the start time. If it continues overnight, enable \"Ends on another day\".": "Pour un event sur une seule journée, l'heure de fin doit être après l'heure de début. S'il continue pendant la nuit, activez \"Se termine un autre jour\".",
    "Some required information is missing. Please complete the highlighted fields to continue.": "Certaines informations obligatoires sont manquantes. Complétez les champs surlignés pour continuer.",
    "The end date cannot be the same as the start date when this option is enabled. If the event ends the same day, uncheck \"Ends on another day\".": "La date de fin ne peut pas être identique à la date de début quand cette option est activée. Si l'event se termine le même jour, décochez \"Se termine un autre jour\".",
    "The end date must be after the start date for a multi-day event. If the event ends the same day, turn this option off.": "Pour un event sur plusieurs jours, la date de fin doit être après la date de début. Si l'event se termine le même jour, désactivez cette option.",
    "City": "Ville",
    "Country": "Pays",
    "e.g. Paris": "ex. Paris",
    "e.g. France": "ex. France",
    "Full Address": "Adresse complète",
    "Full venue address including building and postal code": "Adresse complète du lieu, incluant bâtiment et code postal",
    "Share the full address later": "Partager l'adresse complète plus tard",
    "Keep the exact venue private until shortly before the event starts.": "Gardez le lieu exact privé jusqu'à peu avant le début de l'event.",
    "Useful if you want to reveal the exact venue shortly before the event by email.": "Utile si vous souhaitez révéler le lieu exact peu avant l'event par email.",
    "Reveal {{hours}}h before start": "Révéler {{hours}}h avant le début",
    "Platform": "Plateforme",
    "e.g. Zoom, Teams, Google Meet": "ex. Zoom, Teams, Google Meet",
    "Online Link": "Lien en ligne",
    "https://meeting-platform.com/your-link": "https://plateforme-reunion.com/votre-lien",
    "Allow registration after the event starts": "Autoriser l'inscription après le début de l'event",
    "Useful for live webinars or hybrid sessions where attendees can still join after the opening.": "Utile pour les webinaires en direct ou les sessions hybrides où les participants peuvent encore rejoindre après l'ouverture.",
    "If enabled, participants will still be able to join while the event is live.": "Si activé, les participants pourront encore rejoindre l'event pendant qu'il est en direct.",
    "Share the meeting link later": "Partager le lien de réunion plus tard",
    "Show only the platform at publication, then reveal the full access link shortly before the event.": "Afficher seulement la plateforme à la publication, puis révéler le lien d'accès complet peu avant l'event.",
    "Disabled because attendees must receive the full meeting link immediately when live registration is allowed.": "Désactivé car les participants doivent recevoir le lien complet immédiatement lorsque l'inscription en direct est autorisée.",
    "Useful if you want to send the exact meeting link closer to the session start.": "Utile si vous souhaitez envoyer le lien exact de réunion plus près du début de la session.",
    "Max Participants": "Nombre maximum de participants",
    "Limited": "Limité",
    "Set a maximum number of participants": "Définir un nombre maximum de participants",
    "Allow registrations without a hard cap": "Autoriser les inscriptions sans limite stricte",
    "No registration limit will be applied to this event.": "Aucune limite d'inscription ne sera appliquée à cet event.",
    "Registration Mode": "Mode d'inscription",
    "Manual Review": "Validation manuelle",
    "You approve each registration": "Vous validez chaque inscription",
    "Auto-Confirm": "Confirmation auto",
    "Registrations confirmed instantly": "Inscriptions confirmées instantanément",
    "Live registration requires instant access, so the event is automatically switched to Auto-Confirm.": "L'inscription en direct nécessite un accès instantané, donc l'event bascule automatiquement en confirmation auto.",
    "Registration Deadline": "Date limite d'inscription",
    "If empty, registrations close at event start.": "Si laissé vide, les inscriptions se ferment au début de l'event.",
    "Description": "Description",
    "Describe the scientific scope, agenda structure, and target audience…": "Décrivez le périmètre scientifique, la structure de l'agenda et le public visé…",
    "Generate Preview": "Générer l'aperçu",
    "Publish Now": "Publier maintenant",
    "Publishing...": "Publication...",
    "Description is required.": "La description est obligatoire.",
    "Failed to publish event.": "Impossible de publier l'event.",
    "Event Published!": "Event publié !",
    "Your event is now live and visible to the research community on Neurovent.": "Votre event est maintenant en ligne et visible par la communauté de recherche sur Neurovent.",
    "View Event": "Voir l'event",
    "Back to Dashboard": "Retour au dashboard",
    "Organized by {{name}}": "Organisé par {{name}}",
    "Location": "Lieu",
    "Registration": "Inscription",
    "Capacity": "Capacité",
    "Duration": "Durée",
    "link later": "lien plus tard",
    "full address later": "adresse complète plus tard",
    "Manual": "Manuelle",
    "{{count}} participants": "{{count}} participants",
    "Live registration": "Inscription en direct",
    "Allowed while live": "Autorisée en direct",
    "Closes at start": "Se ferme au début",
    "Unsaved event": "Event non enregistré",
    "This event is not saved yet": "Cet event n'est pas encore enregistré",
    "If you leave this page now, your event draft will be lost.": "Si vous quittez cette page maintenant, votre brouillon d'event sera perdu.",
    "Leave without saving": "Quitter sans enregistrer",
    "YYYY/MM/DD or DD/MM/YYYY": "AAAA/MM/JJ ou JJ/MM/AAAA",
    "Select a date": "Sélectionner une date",
    "Type a date or open the date picker": "Saisir une date ou ouvrir le sélecteur de date",
    "Open date picker": "Ouvrir le sélecteur de date",
    "Previous month": "Mois précédent",
    "Next month": "Mois suivant",
    "Master 2, PhD, Postdoc...": "Master 2, doctorat, postdoc...",
    "Select a domain": "Sélectionner un domaine",
    "Personal Website": "Site personnel",
    "Save Profile": "Enregistrer le profil",
    "Change Password": "Modifier le mot de passe",
    "Password updated successfully.": "Mot de passe mis à jour avec succès.",
    "Current Password": "Mot de passe actuel",
    "Confirm New Password": "Confirmer le nouveau mot de passe",
    "Danger Zone": "Zone de danger",
    "Permanently delete your account and all associated data. This action cannot be undone.": "Supprimez définitivement votre compte et toutes les données associées. Cette action est irréversible.",
    "Deleting...": "Suppression...",
    "Confirm — delete my account": "Confirmer — supprimer mon compte",
    "Delete My Account": "Supprimer mon compte",
    "Cancel": "Annuler",
    "Unsaved changes": "Modifications non enregistrées",
    "Your profile is not saved yet": "Votre profil n'est pas encore enregistré",
    "If you leave this page now, your latest profile changes will be lost.": "Si vous quittez cette page maintenant, vos dernières modifications du profil seront perdues.",
    "Stay here": "Rester ici",
    "Failed to change password.": "Impossible de modifier le mot de passe.",
    "Failed to delete account.": "Impossible de supprimer le compte.",
    "Failed to save.": "Impossible d'enregistrer.",
    "Organization Name": "Nom de l'organisation",
    "Contact Email": "Email de contact",
    "Logo URL": "URL du logo",
    "Organization Description": "Description de l'organisation",
    "Update Organization Identity": "Mettre à jour l'identité de l'organisation",
    "Permanently delete this organization account. This action cannot be undone.": "Supprimez définitivement ce compte organisation. Cette action est irréversible.",
    "Confirm — delete this account": "Confirmer — supprimer ce compte",
    "Delete Organization Account": "Supprimer le compte organisation",
    "Your organization": "Votre organisation",
    "{{count}} / {{max}} registered": "{{count}} / {{max}} inscrits",
    "Search Results": "Résultats de recherche",
    "{{count}} event result{{suffix}}": "{{count}} event trouvé{{suffix}}",
    "{{count}} organization result{{suffix}}": "{{count}} organisation trouvée{{suffix}}",
    "{{events}} event{{eventSuffix}} • {{organizations}} organization{{organizationSuffix}}": "{{events}} event{{eventSuffix}} • {{organizations}} organisation{{organizationSuffix}}",
    "{{count}} public event{{suffix}}": "{{count}} event public{{suffix}}",
    "No events found": "Aucun event trouvé",
    "Try adjusting your search or clearing the active filters.": "Essayez d'ajuster votre recherche ou d'effacer les filtres actifs.",
    "Reset filters": "Réinitialiser les filtres",
    "No description available yet.": "Aucune description disponible pour le moment.",
    "Online Session": "Session en ligne",
    "Unlimited": "Illimité",
    "{{count}} left": "{{count}} restantes",
    "Prev": "Préc.",
    "Next": "Suiv.",
    "Pending": "En attente",
    "Waitlist": "Waitlist",
    "Registered": "Inscrit",
    "Ended": "Terminé",
    "Closed": "Fermé",
    "Join Live": "Rejoindre en direct",
    "Full": "Complet",
    "Join Waitlist": "Rejoindre la waitlist",
    "Access Restricted": "Accès restreint",
    "You must be logged in to register for scientific events.": "Vous devez être connecté pour vous inscrire à des events scientifiques.",
    "Sign In to Account": "Se connecter au compte",
    "Create New Identity": "Créer un nouveau profil",
    "Continue browsing this event": "Continuer à consulter cet event",
    "Explore Events": "Explorer les events",
    "Create Account": "Créer un compte",
    "Upcoming": "À venir",
    "Live": "En cours",
    "May 20": "20 mai",
    "Workshop FL & Privacy — Paris": "Atelier FL & Privacy — Paris",
    "Multi-Agent Systems Practice": "Pratique des systèmes multi-agents",
    "ML Security Conference — Lyon": "Conférence ML Security — Lyon",
    "For participants": "Pour les participants",
    "How it works": "Comment ça marche",
    "Browse events": "Parcourir les events",
    "Filter by format, tags, city or date. Find workshops, conferences and seminars that match your research.": "Filtrez par format, tags, ville ou date. Trouvez des ateliers, conférences et séminaires adaptés à votre recherche.",
    "Register in one click": "S'inscrire en un clic",
    "Instant confirmation or manual validation depending on the organizer. You get notified by email at every step.": "Confirmation instantanée ou validation manuelle selon l'organisateur. Vous recevez un email à chaque étape.",
    "Attend & connect": "Participer et échanger",
    "Join in person or online. Access the full address and link once confirmed.": "Rejoignez l'event en présentiel ou en ligne. Accédez à l'adresse complète et au lien une fois confirmé.",
    "For organizations": "Pour les organisations",
    "Everything you need to organize research events": "Tout ce qu'il faut pour organiser des events de recherche",
    "Publish in minutes": "Publier en quelques minutes",
    "Create your event with title, description, tags, format and capacity. It goes live immediately.": "Créez votre event avec titre, description, tags, format et capacité. Il est publié immédiatement.",
    "Manage registrations": "Gérer les inscriptions",
    "Approve or reject participants individually. Auto-confirm mode available for open events.": "Approuvez ou rejetez les participants individuellement. Le mode auto-confirmation est disponible pour les events ouverts.",
    "Track attendance": "Suivre la participation",
    "Real-time stats: confirmed, pending, waitlist. Export the full list as CSV anytime.": "Stats en temps réel : confirmés, en attente, waitlist. Exportez la liste complète en CSV à tout moment.",
    "Control visibility": "Contrôler la visibilité",
    "Choose when to reveal the full address or online link — before or after confirmation.": "Choisissez quand révéler l'adresse complète ou le lien en ligne — avant ou après confirmation.",
    "Ready to join the community?": "Prêt à rejoindre la communauté ?",
    "Register as a participant to discover and attend events,": "Inscrivez-vous comme participant pour découvrir et rejoindre des events,",
    "or create an organization account to publish your own.": "ou créez un compte organisation pour publier les vôtres.",
    "Register as Participant": "S'inscrire comme participant",
    "Organization Sign In": "Connexion organisation",
    "© 2026 Neurovent — Scientific Event Platform": "© 2026 Neurovent — Plateforme d'events scientifiques",
    "Events published": "Events publiés",
    "Participants registered": "Participants inscrits",
    "Partner organizations": "Organisations partenaires",
    "Countries": "Pays",
    "No topics selected yet.": "Aucun topic sélectionné pour le moment.",
    "Completed": "Complété",
    "Almost there": "Bientôt atteint",
    "Locked": "Verrouillé",
    "{{count}} month{{suffix}}": "{{count}} mois",
    "{{count}} year{{suffix}}": "{{count}} an{{suffix}}",
    "{{years}} year{{yearSuffix}} {{months}} month{{monthSuffix}}": "{{years}} an{{yearSuffix}} {{months}} mois",
    "Unknown join date": "Date d'inscription inconnue",
    "Delete this participant account? This action cannot be undone.": "Supprimer ce compte participant ? Cette action est irréversible.",
    "Unable to delete this participant right now.": "Impossible de supprimer ce participant pour le moment.",
    "Suspend this participant account?": "Suspendre ce compte participant ?",
    "Reactivate this participant account?": "Réactiver ce compte participant ?",
    "Unable to update this participant status.": "Impossible de mettre à jour le statut de ce participant.",
    "Review participant accounts, open their profile pages, and remove accounts when moderation is needed.": "Examinez les comptes participants, ouvrez leurs profils et supprimez des comptes si une modération est nécessaire.",
    "Search any participant field...": "Rechercher dans tous les champs participant...",
    "View All": "Tout voir",
    "{{count}} participant{{suffix}}": "{{count}} participant{{suffix}}",
    "Loading participants...": "Chargement des participants...",
    "No participants match the current search.": "Aucun participant ne correspond à la recherche actuelle.",
    "No email available": "Aucun email disponible",
    "Active": "Actif",
    "Inactive": "Inactif",
    "Joined {{date}}": "Inscrit le {{date}}",
    "Match in {{reason}}": "Correspondance dans {{reason}}",
    "Suspend": "Suspendre",
    "Reactivate": "Réactiver",
    "Delete": "Supprimer",
    "Delete this organization account while it is still pending verification? This action cannot be undone.": "Supprimer ce compte organisation alors que sa vérification est encore en attente ? Cette action est irréversible.",
    "Delete this verified organization account? This action cannot be undone.": "Supprimer ce compte organisation vérifié ? Cette action est irréversible.",
    "Unable to delete this organization right now.": "Impossible de supprimer cette organisation pour le moment.",
    "Unable to update this verification status.": "Impossible de mettre à jour ce statut de vérification.",
    "Monitor organization accounts, validate pending applications, and review every company currently active on the platform.": "Surveillez les comptes organisations, validez les demandes en attente et examinez toutes les entreprises actuellement actives sur la plateforme.",
    "Search any organization field...": "Rechercher dans tous les champs organisation...",
    "Pending Verification": "Vérification en attente",
    "{{count}} waiting review": "{{count}} en attente de revue",
    "No organization is currently waiting for manual review.": "Aucune organisation n'attend actuellement de revue manuelle.",
    "No recovery email": "Aucun email de récupération",
    "SIRET {{value}}": "SIRET {{value}}",
    "Review reason: {{reason}}": "Motif de revue : {{reason}}",
    "Review reason: automatic verification found missing or inconsistent company details.": "Motif de revue : la vérification automatique a détecté des informations d'entreprise manquantes ou incohérentes.",
    "View profile": "Voir le profil",
    "Approve": "Approuver",
    "Reject": "Rejeter",
    "Verified Organizations": "Organisations vérifiées",
    "Loading companies...": "Chargement des organisations...",
    "No verified organizations match the current search.": "Aucune organisation vérifiée ne correspond à la recherche actuelle.",
    "{{count}} organization{{suffix}}": "{{count}} organisation{{suffix}}",
    "Verified": "Vérifié",
    "Rejected": "Rejeté",
    "Needs Review": "À revoir",
    "missing": "manquant",
    "All statuses": "Tous les statuts",
    "Published": "Publié",
    "Draft": "Brouillon",
    "Cancelled": "Annulé",
    "All formats": "Tous les formats",
    "Unknown date": "Date inconnue",
    "Inspect every published, draft, or cancelled event across the platform and remove entries when moderation requires it.": "Inspectez tous les events publiés, brouillons ou annulés sur la plateforme et supprimez des entrées quand la modération l'exige.",
    "Search by event title or organization...": "Rechercher par titre d'event ou organisation...",
    "{{count}} event{{suffix}}": "{{count}} event{{suffix}}",
    "Upcoming & Live": "À venir et en cours",
    "Past": "Passé",
    "Loading events...": "Chargement des events...",
    "No events match the current filters.": "Aucun event ne correspond aux filtres actuels.",
    "Unknown organization": "Organisation inconnue",
    "View Detail": "Voir le détail",
    "Companies": "Entreprises",
    "Admins": "Admins",
    "Loading platform statistics...": "Chargement des statistiques de la plateforme...",
    "A global view of growth, moderation load, event publishing, and registration activity across the whole platform.": "Une vue globale de la croissance, de la charge de modération, de la publication des events et de l'activité des inscriptions sur l'ensemble de la plateforme.",
    "Total participant accounts": "Nombre total de comptes participants",
    "Organization accounts on the platform": "Comptes organisations sur la plateforme",
    "Django admin accounts": "Comptes administrateur Django",
    "Active Accounts": "Comptes actifs",
    "Currently active users across all roles": "Utilisateurs actuellement actifs sur tous les rôles",
    "{{count}} created this month": "{{count}} créés ce mois-ci",
    "Event Views": "Vues des events",
    "Total public event detail views": "Nombre total de vues publiques des détails d'events",
    "Registrations": "Inscriptions",
    "All registration records": "Tous les enregistrements d'inscription",
    "New Users": "Nouveaux utilisateurs",
    "Accounts created this month": "Comptes créés ce mois-ci",
    "Company Verification": "Vérification des entreprises",
    "Registrations by Status": "Inscriptions par statut",
    "Events by Status": "Events par statut",
    "Events by Format": "Events par format",
    "Top Events by Confirmed Registrations": "Top des events par inscriptions confirmées",
    "{{count}} confirmed": "{{count}} confirmés",
    "{{count}} pending": "{{count}} en attente",
    "Loading participant profile...": "Chargement du profil participant...",
    "Back to Participants": "Retour aux participants",
    "This participant profile could not be loaded.": "Ce profil participant n'a pas pu être chargé.",
    "Unable to delete this participant.": "Impossible de supprimer ce participant.",
    "Suspend Participant": "Suspendre le participant",
    "Reactivate Participant": "Réactiver le participant",
    "Delete Participant": "Supprimer le participant",
    "Unable to delete this organization.": "Impossible de supprimer cette organisation.",
    "Back to Organizations": "Retour aux organisations",
    "Delete Organization": "Supprimer l'organisation",
    "This organization is waiting for manual validation because some company details are missing or inconsistent.": "Cette organisation attend une validation manuelle car certaines informations de l'entreprise sont manquantes ou incohérentes.",
    "Organization profile": "Profil de l'organisation",
    "Registration failed. Please try again.": "L'inscription a échoué. Veuillez réessayer.",
    "Failed to cancel registration.": "Impossible d'annuler l'inscription.",
    "Failed to remove this registration.": "Impossible de supprimer cette inscription.",
    "Delete this event? This action cannot be undone.": "Supprimer cet event ? Cette action est irréversible.",
    "Unable to delete this event.": "Impossible de supprimer cet event.",
    "Back to admin events": "Retour aux events admin",
    "Back to results": "Retour aux résultats",
    "Back to discovery": "Retour à la découverte",
    "Event started": "Event démarré",
    "Starts in {{count}} day{{suffix}}": "Commence dans {{count}} jour{{suffix}}",
    "Starts in {{count}} hour{{suffix}}": "Commence dans {{count}} heure{{suffix}}",
    "Starts in {{count}} min": "Commence dans {{count}} min",
    "Registration closes in {{count}} day{{suffix}}": "Les inscriptions ferment dans {{count}} jour{{suffix}}",
    "Registration closes in {{count}} hour{{suffix}}": "Les inscriptions ferment dans {{count}} heure{{suffix}}",
    "Registration closes in {{count}} min": "Les inscriptions ferment dans {{count}} min",
    "Registration closed": "Inscriptions fermées",
    "No registration deadline": "Aucune date limite d'inscription",
    "Event not found.": "Event introuvable.",
    "Unknown": "Inconnu",
    "No description available.": "Aucune description disponible.",
    "Tags": "Tags",
    "{{count}} spots left": "{{count}} places restantes",
    "Exporting...": "Export en cours...",
    "Export CSV": "Exporter le CSV",
    "No registrations yet.": "Aucune inscription pour le moment.",
    "Registered {{date}}": "Inscrit le {{date}}",
    "Remove registration": "Supprimer l'inscription",
    "Management": "Gestion",
    "Event Info": "Infos event",
    "Status": "Statut",
    "Edit Event": "Modifier l'event",
    "Hide Registrations": "Masquer les inscriptions",
    "View Registrations": "Voir les inscriptions",
    "Click again to confirm": "Cliquer encore pour confirmer",
    "Delete Event": "Supprimer l'event",
    "Admin moderation view for this event.": "Vue de modération admin pour cet event.",
    "This event is managed by another organization.": "Cet event est géré par une autre organisation.",
    "Manual validation required by organizer.": "Validation manuelle requise par l'organisateur.",
    "Waitlist position saved": "Position en waitlist enregistrée",
    "Pending validation": "Validation en attente",
    "Cancelling...": "Annulation...",
    "Cancel Registration": "Annuler l'inscription",
    "Event Ended": "Event terminé",
    "Registration Closed": "Inscriptions fermées",
    "Register to Event": "S'inscrire à l'event",
    "Back to event description": "Retour à la description de l'event",
  },
};

export function interpolate(template, params = {}) {
  return Object.entries(params).reduce(
    (acc, [key, value]) => acc.replaceAll(`{{${key}}}`, String(value)),
    template
  );
}
